"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/CCFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_41)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_41`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-10.6799 0H25.3201V24H-10.6799V0Z",
					fill: "#008000"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.9832 17.7123L19.4183 18.6106L20.3868 18.386L19.9517 19.2842L20.7376 19.9018L19.7622 20.1263V21.1228L18.9832 20.4983L18.2043 21.1228V20.1263L17.2359 19.9018L18.0148 19.2842L17.5797 18.386L18.5552 18.6106L18.9832 17.7123ZM15.7131 8.14739L16.1482 9.05266L17.1166 8.82809L16.6815 9.72634L17.4675 10.3439L16.492 10.5614V11.5649L15.7131 10.9404L14.9341 11.5649L14.9411 10.5614L13.9657 10.3439L14.7446 9.72634L14.3096 8.82809L15.285 9.05266L15.7131 8.14739ZM18.3096 2.68774L18.7446 3.58599L19.7131 3.36143L19.278 4.25967L20.0639 4.88424L19.0885 5.10178V6.09827L18.3096 5.47371L17.5306 6.09827L17.5376 5.10178L16.5622 4.88424L17.3411 4.25967L16.906 3.36143L17.8815 3.58599L18.3096 2.68774ZM21.9446 6.78599L22.3797 7.68424L23.3552 7.45967L22.9131 8.35792L23.699 8.98248L22.7236 9.20003L22.7306 10.1965L21.9446 9.57195L21.1657 10.1965L21.1727 9.20003L20.1973 8.98248L20.9832 8.35792L20.5411 7.45967L21.5166 7.68424L21.9446 6.78599ZM19.9797 11.5649L20.3236 12.6035H21.4183L20.5341 13.2491L20.871 14.2948L19.9797 13.6491L19.0955 14.2948L19.4324 13.2491L18.5482 12.6035H19.6429L19.9797 11.5649Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.8499 17.8737C7.39727 17.8737 4.59727 15.0737 4.59727 11.6211C4.59727 8.16848 7.39727 5.36848 10.8499 5.36848C11.9236 5.36848 12.9411 5.64217 13.8253 6.11936C12.4359 4.76497 10.5341 3.92989 8.44288 3.92989C4.19727 3.92989 0.751656 7.3755 0.751656 11.6211C0.751656 15.8667 4.19727 19.3194 8.44288 19.3194C10.5341 19.3194 12.4359 18.4843 13.8183 17.1229C12.9341 17.6001 11.9236 17.8737 10.8499 17.8737ZM-0.827291 4.1755C-1.57817 2.87726 -2.98168 2.00708 -4.58869 2.00708C-6.19571 2.00708 -7.5922 2.87726 -8.34308 4.1755H-0.827291ZM-0.813256 4.20357L-4.58869 7.97901L-8.35712 4.20357C-8.71501 4.83515 -8.92554 5.56498 -8.92554 6.35094C-8.92554 8.75094 -6.98168 10.6948 -4.58168 10.6948C-2.18168 10.6948 -0.237818 8.75094 -0.237818 6.35094C-0.244835 5.56498 -0.455361 4.83515 -0.813256 4.20357Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_41`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as CCFlag };
